<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="bread">
        <a
          href="#"
          v-for="(step, index) in steps"
          :key="index"
          :class="{ active: step.index === currentStep }"
          ><span class="badge badge-secondary font-size-12">{{
            step.index
          }}</span>
          {{ step.libelle }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['steps', 'currentStep'],
};
</script>

<style lang="css" scoped>
.bread {
  margin-right: 20px;
}
.bread a {
  position: relative;
  float: left;
  padding-left: 30px;
  padding-right: 10px;
  text-decoration: none;
  line-height: 36px;
  color: black;
  background: white;
  transition: all 0.5s;
  margin-top: 10px;
}

.bread a::after {
  content: '';
  position: absolute;
  top: 0;
  right: -20px;
  z-index: 1;
  width: 36px;
  height: 36px;
  background: white;
  box-shadow: 1px 1px 0 1px #ddd;
  border-radius: 50px 0 0 0;
  transform: rotate(-45deg) scale(0.73);
  transition: all 0.5s;
}

.bread a.active,
.bread a.active::after {
  background: #efd790;
}

.bread a:first-child {
  padding-left: 10px;
}

.bread a:first-child::before {
  left: 140px;
}
</style>
